import axiosInstance from './base.api';
import { RankFilters } from './decisions.api';

export interface GetPatientInfoResponseDTO {
    email: string;
    quiz: [];
    treatment_choice: {
        app_id: number;
        dataset_id: number;
        treatment: number;
        chosen: true;
    }[];
}

export interface PatientTreatmentInfo {
    appId: string;
    datasetId: string;
    treatmentId: string;
    chosen: boolean;
}

export const getPatientInfo = async (): Promise<PatientTreatmentInfo[]> => {
    const response = await axiosInstance.post<GetPatientInfoResponseDTO>('/patient/getinfo');
    return response.data.treatment_choice.map(choice => {
        return {
            appId: choice.app_id + '',
            datasetId: choice.dataset_id + '',
            treatmentId: choice.treatment + '',
            chosen: choice.chosen,
        };
    });
};

export const saveOrganicPatientQuizResults = async (quizResults: {
    question: string;
    patientAnswer: string;
    tag: string;
} []): Promise<boolean> => {
    const response = await axiosInstance.post<GetPatientInfoResponseDTO>('/patient/organic-quiz', quizResults);
    return response.status === 200;
};

export const savePatientQuizResults = async (quizResults: {
    question: string;
    patientAnswer: string;
    correctAnswer: string;
} []): Promise<boolean> => {
    const response = await axiosInstance.post('/patient/quiz?app_id=0&dataset_id=0', quizResults);
    return response.status === 200;
};

export const markPageVisited = async ({
    pageName,
    pageType,
}: {
    pageName: string;
    pageType: 'treatment' | 'criteria'
}): Promise<void> => {
    await axiosInstance.post<GetPatientInfoResponseDTO>('/patient/visit-page?app_id=0&dataset_id=0', {
        pageId: pageName,
        pageName,
        pageType,
    });
};

export const chooseTreatment = async (data: {
    appId: string;
    datasetId: string;
    criteria: RankFilters['criteria'],
    constraints?: RankFilters['constraints'],
    treatmentId: string;
}): Promise<void> => {
    await axiosInstance.post<GetPatientInfoResponseDTO>('/patient/choose-treatment', {
        app_id: data.appId,
        dataset_id: data.datasetId,
        treatment_id: data.treatmentId,
        criteria: data.criteria,
        constraints: data.constraints,
    });
};
